import type { FC } from 'react';
import type { CustomerOrderPaymentDto, CustomerOrderPaymentKind } from '@/api';
import { cn } from '@/ui';

import { formatDate, formatMoney, toNumber } from '../lib/format';

const KINDS: Record<CustomerOrderPaymentKind, string> = {
  Bank: 'банк',
  Cash: 'касса',
};

/**
 * Оплаты заказа 1С - поступления, которые 1С относит к заказу: документ и вид
 * слева, сумма справа. Общий для карточки отгрузки (вкладка и подсказка оплаты)
 * и карточки заказа 1С. Цвет текста наследуется: список живёт и на тёмной
 * подложке подсказки.
 */
export const PaymentList: FC<{
  payments: ReadonlyArray<CustomerOrderPaymentDto>;
  className?: string;
}> = ({ payments, className }) => (
  <ul className={cn('m-0 flex list-none flex-col gap-1 p-0', className)}>
    {payments.map((payment, index) => (
      // Ключа у оплаты нет: сводка приходит из 1С целиком, порядок - по дате.
      <li key={index} className="flex items-baseline justify-between gap-3">
        <span className="min-w-0">
          № {payment.number} от {formatDate(payment.date)}
          <span className="opacity-70"> · {KINDS[payment.kind]}</span>
        </span>
        <span className="font-semibold whitespace-nowrap tabular-nums">
          {formatMoney(toNumber(payment.amount))}
        </span>
      </li>
    ))}
  </ul>
);
